export const customColor = {
  primary: ` #ffffff`,
  secondary: ` #265df5`,
  tertiary: ` #3d3d3d`,
  footer_bg: ` #142057`,
  secondary_dark: ` #19328f`,
  success: "lightgreen",
  tertiary_light: `#e0e0e0`,
  tertiary_grey: `#6d6d6d`,
};
